import AnalyticCard from "../../analyticCard/analyticCard";

const CardDashboard = () => {
    const a = <br/>
    return(
        <div className={'grid col-2'}>
            <div className="">
                <div className="sf-medium font-18 margin-b-15">Fleet Performance</div>
                <ul className="grid col-2">
                    <AnalyticCard data={{number: 23, title: <span>Active<br/> Vehicles</span>}}/>
                    <AnalyticCard color={'#6088D0'}
                                  backColor={'#F5F5F5'}
                                  data={{number: 19, title: <span>Average<br/>Alerts</span>}}/>
                </ul>
            </div>
            <div className="">
                <div className="sf-medium font-18 margin-b-15">Driver Performance</div>
                <ul className="grid col-2">
                    <AnalyticCard color={'#36BA6E'}
                                  backColor={'#E3F5EA'}
                                  data={{number: 58, title: <span>Improved<br/> Drivers</span>}}/>
                    <AnalyticCard color={'#6088D0'}
                                  backColor={'#F5F5F5'}
                                  data={{number: '26', suf: '%', title: <span>Faster</span>}}/>
                </ul>
            </div>
        </div>
    )
}

export default CardDashboard;
